const config = {
    //"wsurl" : window.location.hostname,
    "wsurl" : "https://ws1.ypcloud.com",
    "loginurl": "https://account.ypcloud.com/auth/verify/?ReturnURL=https://jujue.app/callback",
    //"loginurl": "https://account.ypcloud.com/auth/verify/?ReturnURL=http://localhost:8085/callback",
    "logouturl": "https://account.ypcloud.com/auth/logout/?ReturnURL=https://jujue.app/",
    //"logouturl": "https://account.ypcloud.com/auth/logout/?ReturnURL=http://localhost:8085",
    "profileurl": "https://account.ypcloud.com/auth/profile",
    //"setdeviceurl": "https://account.ypcloud.com/#/settings?ReturnURL=http://localhost:8085",
    "setdeviceurl": "https://account.ypcloud.com/#/settings?ReturnURL=https://jujue.app/",
};

export default config;
